import React, { useEffect, useState, useRef } from "react";
import Board from "react-trello";
import { Card } from "react-bootstrap";
import DialogLayout from "../../../../partials/content/DialogLayout";
import { KeyboardDatePicker } from "@material-ui/pickers";
import SalesCardForm from "./salesCardForm";
import { Cancel, People, PeopleOutline, Search } from "@mui/icons-material";
import {
  getBoardSalesCards,
  updateSalesCardStatus,
  getSalesCardDetail,
} from "../../../../services/crm/salesCardService";
import { Badge } from "react-bootstrap";
import {
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@material-ui/core";
import { DialogActions } from "@material-ui/core";
import NumberFormat from "react-number-format";
import SalesCardDetail from "./salesCardDetail";
import Swal from "sweetalert2";
import { toAbsoluteUrl } from "../../../../../_metronic";
import { OverlayPanel } from "primereact/overlaypanel";
import {
  getRandomColor,
  createImageFromInitials,
} from "../../../../partials/layout/Avatar";
import { Image } from "react-bootstrap";
import { abbrNum, formatDate } from "../../../../utils/utils";
import ConvertToSalesOrderWizard from "../../sales/quotation/quotationForm/convertToSalesOrderWizard";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import { withStyles } from "@material-ui/core/styles";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import { PageSubHeader } from "../../../../../provider/PageDataProvider";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import { DateTime } from "luxon";
import SearchCustomer from "../../sales/customers/searchCustomer";
import SearchLead from "../leads/searchLead";
import SearchUser from "../../users/users/searchUser";
const HtmlBootstrapTooltip = withStyles((theme) => ({
  tooltip: {
    fontSize: theme.typography.pxToRem(12),
    width: 400,
    padding: 0,
  },
}))(BootstrapTooltip);
function Slc({ match, history }) {
  const salesCardIDImport = match.params.salesCardID;
  const { companyProfile, reload } = useGlobalData();
  const selectParamOp = useRef(null);
  const [selectParam, setSelectParam] = useState({
    dateFrom: DateTime.fromISO(companyProfile.CreatedAt).startOf("day"),
    dateTo: DateTime.now().endOf("day"),
    leadID: 0,
    leadName: "",
    customerID: 0,
    customerName: "",
    assignedUserID: 0,
    assignedUserName: "",
  });
  const [searchByLead, setSearchByLead] = useState(true);
  const [openSearchLead, setOpenSearchLead] = useState(false);
  const [openSearchCustomer, setOpenSearchCustomer] = useState(false);
  const [openSearchSales, setOpenSearchSales] = useState(false);
  const [openSalesCardForm, setOpenSalesCardForm] = useState(false);
  const [openSalesCardDetail, setOpenSalesCardDetail] = useState(false);
  const [salesCardID, setSalesCardID] = useState(0);
  const [openSalesWonDialog, setOpenSalesWonDialog] = useState(false);
  const [boards, setBoards] = useState([]);
  const [auth, setAuth] = useState({});
  const [salesCard, setSalesCard] = useState({
    ID: 0,
    quotationID: 0,
    leadID: 0,
    customerID: 0,
    customer: {
      ID: 0,
    },
  });

  const [cardBoard, setCardBoard] = useState(null);
  useEffect(() => {
    getSalesCardsData();
    if (salesCardIDImport > 0) {
      setSalesCardID(salesCardIDImport);
      setOpenSalesCardDetail(true);
    }
  }, [salesCardIDImport, reload]);

  const actionButtons = [];
  actionButtons.push({
    title: "",
    color: "label-brand",
    icon: "fas fa-backward",
    onClick: () => {
      history.push("/menu");
    },
  });
  actionButtons.push({
    title: "Filter",
    color: "label-info",
    icon: "fas fa-search",
    onClick: (e) => {
      selectParamOp.current.toggle(e);
    },
  });
  if (auth.create) {
    actionButtons.push({
      title: "New Sales Card",
      color: "primary",
      icon: "fas fa-plus-circle",
      onClick: () => {
        const salesCardTmp = { ...salesCard };
        salesCardTmp.ID = 0;
        setSalesCard(salesCardTmp);
        setOpenSalesCardForm(true);
      },
    });
  }
  return (
    <React.Fragment>
      <PageSubHeader
        title="Sales Life Cycle List Board"
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/crm/slc",
            title: "Sales Life Cycles",
            active: true,
          },
        ]}
        actionButtons={actionButtons}
      />
      <OverlayPanel
        ref={selectParamOp}
        showCloseIcon
        dismissable={false}
        id="overlay_panel"
        style={{ width: "450px" }}
        className="overlaypanel-demo"
      >
        <div className="row mb-3">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <Card>
              <Card.Header>
                <i className="fas fa-filter"></i>
                <span>
                  <strong>Filter Selection</strong>
                </span>
              </Card.Header>
              <Card.Body>
                <div className="row">
                  <div className="col-6">
                    <KeyboardDatePicker
                      label="Date From"
                      autoOk
                      size="small"
                      inputVariant="outlined"
                      variant="inline"
                      margin="normal"
                      value={selectParam.dateFrom}
                      onChange={(date) => {
                        const selectParamTmp = { ...selectParam };
                        selectParamTmp.dateFrom = date;
                        setSelectParam(selectParamTmp);
                      }}
                      format="yyyy-MM-dd"
                      InputProps={{ readOnly: true }}
                    />
                  </div>
                  <div className="col-6">
                    <KeyboardDatePicker
                      label="Date To"
                      autoOk
                      size="small"
                      inputVariant="outlined"
                      variant="inline"
                      margin="normal"
                      value={selectParam.dateTo}
                      onChange={(date) => {
                        const selectParamTmp = { ...selectParam };
                        selectParamTmp.dateTo = date;
                        setSelectParam(selectParamTmp);
                      }}
                      minDate={selectParam.dateFrom}
                      format="yyyy-MM-dd"
                      InputProps={{ readOnly: true }}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    {searchByLead === true ? (
                      <TextField
                        id="leadName"
                        label="Lead Name"
                        value={selectParam.leadName}
                        variant="outlined"
                        size="small"
                        style={{ width: "100%" }}
                        margin="normal"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <BootstrapTooltip title="Search">
                                <IconButton
                                  type="button"
                                  aria-label="Search"
                                  onClick={() => {
                                    setOpenSearchLead(true);
                                  }}
                                  edge="end"
                                >
                                  <Search />
                                </IconButton>
                              </BootstrapTooltip>
                              <BootstrapTooltip title="Clear">
                                <IconButton
                                  type="button"
                                  aria-label="Clear"
                                  onClick={() => {
                                    const selectParamTmp = { ...selectParam };
                                    selectParamTmp.leadID = 0;
                                    selectParamTmp.leadName = "";
                                    selectParamTmp.customerID = 0;
                                    selectParamTmp.customerName = "";
                                    setSelectParam(selectParamTmp);
                                  }}
                                  edge="end"
                                >
                                  <Cancel />
                                </IconButton>
                              </BootstrapTooltip>
                              <BootstrapTooltip title="Search By Customer">
                                <IconButton
                                  type="button"
                                  aria-label="SearchBy"
                                  onClick={() => {
                                    setSearchByLead(false);
                                  }}
                                  edge="end"
                                >
                                  <People />
                                </IconButton>
                              </BootstrapTooltip>
                            </InputAdornment>
                          ),
                          readOnly: true,
                        }}
                      />
                    ) : (
                      <TextField
                        id="customerName"
                        label="Customer Name"
                        value={selectParam.customerName}
                        variant="outlined"
                        size="small"
                        style={{ width: "100%" }}
                        margin="normal"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <BootstrapTooltip title="Search">
                                <IconButton
                                  type="button"
                                  aria-label="Search"
                                  onClick={() => {
                                    setOpenSearchCustomer(true);
                                  }}
                                  edge="end"
                                >
                                  <Search />
                                </IconButton>
                              </BootstrapTooltip>
                              <BootstrapTooltip title="Clear">
                                <IconButton
                                  type="button"
                                  aria-label="Clear"
                                  onClick={() => {
                                    const selectParamTmp = { ...selectParam };
                                    selectParamTmp.leadID = 0;
                                    selectParamTmp.leadName = "";
                                    selectParamTmp.customerID = 0;
                                    selectParamTmp.customerName = "";
                                    setSelectParam(selectParamTmp);
                                  }}
                                  edge="end"
                                >
                                  <Cancel />
                                </IconButton>
                              </BootstrapTooltip>
                              <BootstrapTooltip title="Search By Lead">
                                <IconButton
                                  type="button"
                                  aria-label="SearchBy"
                                  onClick={() => {
                                    setSearchByLead(true);
                                  }}
                                  edge="end"
                                >
                                  <PeopleOutline />
                                </IconButton>
                              </BootstrapTooltip>
                            </InputAdornment>
                          ),
                          readOnly: true,
                        }}
                      />
                    )}
                    <TextField
                      id="assignedUserName"
                      label="Assigned To"
                      value={selectParam.assignedUserName}
                      variant="outlined"
                      size="small"
                      style={{ width: "100%" }}
                      margin="normal"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <BootstrapTooltip title="Search">
                              <IconButton
                                type="button"
                                aria-label="Search"
                                onClick={() => {
                                  setOpenSearchSales(true);
                                }}
                                edge="end"
                              >
                                <Search />
                              </IconButton>
                            </BootstrapTooltip>
                            <BootstrapTooltip title="Clear">
                              <IconButton
                                type="button"
                                aria-label="Clear"
                                onClick={() => {
                                  const selectParamTmp = { ...selectParam };
                                  selectParamTmp.assignedUserID = 0;
                                  selectParamTmp.assignedUserName = "";
                                  setSelectParam(selectParamTmp);
                                }}
                                edge="end"
                              >
                                <Cancel />
                              </IconButton>
                            </BootstrapTooltip>
                          </InputAdornment>
                        ),
                        readOnly: true,
                      }}
                    />
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <button
              type="button"
              className="btn btn-success btn-md btn-pill btn-bold float-right"
              onClick={() => {
                getSalesCardsData();
              }}
            >
              <i className="fas fa-search"></i>
              Get Sales Card
            </button>
          </div>
        </div>
      </OverlayPanel>
      <Board
        components={{
          Card: (card) => (
            <Card className="kanban-card">
              <Card.Body className="pb-0">
                <Card.Title className="mb-0">
                  <div className="row">
                    <BootstrapTooltip title={card.title}>
                      <div className="col-10 kanban-card-title">
                        <strong>{card.title}</strong>
                      </div>
                    </BootstrapTooltip>
                    <div className="col-1">
                      {card.statusID < 9998 ? (
                        <BootstrapTooltip title="Edit Sales Card">
                          <button
                            type="button"
                            className="btn btn-icon btn-label-primary btn-circle btn-md float-right btn-sm btn-icon-sm"
                            onClick={() => {
                              const salesCardTmp = { ...card };
                              salesCardTmp.ID = parseInt(salesCardTmp.ID);
                              setSalesCard(salesCardTmp);
                              setOpenSalesCardForm(true);
                            }}
                          >
                            <i className="fas fa-edit"></i>
                          </button>
                        </BootstrapTooltip>
                      ) : null}
                    </div>
                    <div className="col-1">
                      <BootstrapTooltip title="Sales Card Detail">
                        <button
                          type="button"
                          className="btn btn-icon btn-label-success btn-circle btn-md float-right btn-sm btn-icon-sm"
                          onClick={() => {
                            setSalesCardID(card.ID);
                            setOpenSalesCardDetail(true);
                          }}
                        >
                          <i className="fas fa-list-alt"></i>
                        </button>
                      </BootstrapTooltip>
                    </div>
                  </div>
                </Card.Title>
                <div className="column">
                  {card.customer.ID > 0 ? (
                    <BootstrapTooltip
                      title={`Customer ${card.customer.customerName}`}
                    >
                      <div className="col-sm-12 col-md-12 col-lg-12 px-0 kanban-card-desc">
                        <span className="mr-1">
                          <i className="fas fa-user-tag kt-font-brand"></i>
                        </span>
                        <span className="mr-1 kanban-card-desc">
                          Customer {card.customer.customerName}
                        </span>
                      </div>
                    </BootstrapTooltip>
                  ) : card.lead.ID > 0 ? (
                    <BootstrapTooltip title={`Lead ${card.lead.leadName}`}>
                      <div className="col-sm-12 col-md-12 col-lg-12 px-0 kanban-card-desc">
                        <span className="mr-1">
                          <i className="fas fa-user-tag kt-font-brand"></i>
                        </span>
                        <span className="mr-1 kanban-card-desc">
                          Lead {card.lead.leadName}
                        </span>
                      </div>
                    </BootstrapTooltip>
                  ) : null}
                  {card.quotation.ID > 0 ? (
                    <BootstrapTooltip
                      title={`Quotation Value ${
                        card.currency.currencyCode
                      } ${abbrNum(card.quotation.grandTotal, 2)}`}
                    >
                      <div className="col-sm-12 col-md-12 col-lg-12 px-0 kanban-card-desc">
                        <span className="mr-1">
                          <i className="fas fa-money-bill kt-font-brand"></i>
                        </span>
                        <span className="mr-1 kanban-card-desc">
                          Quotation Value{" "}
                          <NumberFormat
                            value={card.quotation.grandTotal}
                            displayType={"text"}
                            thousandSeparator={true}
                            decimalScale={2}
                            renderText={(value) => (
                              <span>{`${card.currency.currencyCode} ${value}`}</span>
                            )}
                          />
                        </span>
                      </div>
                    </BootstrapTooltip>
                  ) : (
                    <BootstrapTooltip
                      title={`Estimation Value ${
                        card.currency.currencyCode
                      } ${abbrNum(card.estimatedValue, 2)}`}
                    >
                      <div className="col-sm-12 col-md-12 col-lg-12 px-0 kanban-card-desc">
                        <span className="mr-1">
                          <i className="fas fa-money-bill kt-font-brand"></i>
                        </span>
                        <span className="mr-1 kanban-card-desc">
                          Estimation Value{" "}
                          <NumberFormat
                            value={card.estimatedValue}
                            displayType={"text"}
                            thousandSeparator={true}
                            decimalScale={2}
                            renderText={(value) => (
                              <span>{`${card.currency.currencyCode} ${value}`}</span>
                            )}
                          />
                        </span>
                      </div>
                    </BootstrapTooltip>
                  )}
                </div>
              </Card.Body>
              <Card.Footer>
                <span className="mr-3">
                  <Badge
                    className="mr-1"
                    variant={
                      card.quotation.ID === 0
                        ? "info"
                        : card.quotation.ID > 0 &&
                          card.quotation.salesStatus === 1
                        ? "warning"
                        : card.quotation.ID > 0 &&
                          card.quotation.salesStatus === 3
                        ? "success"
                        : card.quotation.ID > 0 &&
                          card.quotation.salesStatus === 4
                        ? "danger"
                        : null
                    }
                  >
                    {card.quotation.ID === 0
                      ? "No Quote Yet"
                      : card.quotation.ID > 0 &&
                        card.quotation.salesStatus === 1
                      ? "Quote In Progress"
                      : card.quotation.ID > 0 &&
                        card.quotation.salesStatus === 3
                      ? "Quote Won"
                      : card.quotation.ID > 0 &&
                        card.quotation.salesStatus === 4
                      ? "Quote Lost"
                      : null}
                  </Badge>
                </span>
                <BootstrapTooltip
                  title={`Created At ${formatDate(card.CreatedAt)}`}
                >
                  <span className="mr-3">
                    <span className="mr-1">
                      <i className="fas fa-clock kt-font-brand"></i>
                    </span>
                    <span className="mr-1">{formatDate(card.CreatedAt)}</span>
                  </span>
                </BootstrapTooltip>
                {card.assignedUserName ? (
                  <React.Fragment>
                    {card.assignedUser.userImage ? (
                      <HtmlBootstrapTooltip
                        title={
                          <React.Fragment>
                            <div
                              className="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x"
                              style={{
                                backgroundImage: `url(${toAbsoluteUrl(
                                  "/media/bg/450.jpg"
                                )})`,
                              }}
                            >
                              <div className="kt-user-card__avatar">
                                <React.Fragment>
                                  <Typography align="center">
                                    <Image
                                      src={
                                        card.assignedUser.userImage.length === 0
                                          ? createImageFromInitials(
                                              150,
                                              card.assignedUserName,
                                              getRandomColor()
                                            )
                                          : card.assignedUser.userImage[0]
                                              .imagePath
                                      }
                                      roundedCircle
                                      alt="Avatar"
                                      fluid
                                    />
                                  </Typography>
                                </React.Fragment>
                              </div>
                              <div className="kt-user-card__name">
                                <div className="row">
                                  <div className="col-sm-12 col-md-12 col-lg-12">
                                    <ResponsiveEllipsis
                                      text={card.assignedUserName}
                                      maxLine="1"
                                    />
                                    {card.assignedGroupName ? (
                                      <div className="kt-user-card__subname mt-2">
                                        <ResponsiveEllipsis
                                          text={card.assignedGroupName}
                                          maxLine="1"
                                        />
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </React.Fragment>
                        }
                      >
                        <Image
                          src={
                            card.assignedUser.userImage.length === 0
                              ? createImageFromInitials(
                                  150,
                                  card.assignedUserName,
                                  getRandomColor()
                                )
                              : card.assignedUser.userImage[0].imagePath
                          }
                          style={{
                            maxHeight: "25px",
                          }}
                          alt="Avatar"
                          roundedCircle
                          fluid
                          className="float-right"
                        />
                      </HtmlBootstrapTooltip>
                    ) : null}
                  </React.Fragment>
                ) : null}
              </Card.Footer>
            </Card>
          ),
        }}
        data={{ lanes: boards }}
        collapsibleLanes
        handleDragEnd={(cardId, sourceLaneId, targetLaneId, position, card) => {
          if (targetLaneId === "9998") {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            })
              .fire({
                title:
                  "Are you sure want to close this Sales Card as Sales Lost ?",
                text: "Please note that you are responsible for this action",
                icon: "question",
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, close it`,
                cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
                reverseButtons: true,
              })
              .then((result) => {
                if (result.isConfirmed) {
                  dragCard(card, 9998).then((response) => {
                    getSalesCardsData().then((response) => {
                      Swal.mixin({
                        customClass: {
                          confirmButton:
                            "btn btn-success btn-md btn-pill btn-bold",
                        },
                        buttonsStyling: false,
                      }).fire({
                        title: "Closed as Sales Lost",
                        text: `We are sorry for the loss in your sale :(. Good luck next time`,
                        icon: "success",
                        showCloseButton: true,
                        confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                      });
                    });
                  });
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  }).fire({
                    title: "Cancelled",
                    text: "No change has been made",
                    icon: "info",
                    showCloseButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                  });
                  getSalesCardsData().then((response) => {});
                }
              });
          } else if (targetLaneId === "9999") {
            if (card.quotationID > 0) {
              getSalesCardData(card.id).then((response) => {
                setCardBoard(card);
                setOpenSalesWonDialog(true);
              });
            } else {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Failed",
                text: "This Sales Card does not have quotation",
                icon: "error",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
              getSalesCardsData().then((response) => {});
            }
          } else {
            dragCard(card, targetLaneId);
          }
        }}
      />
      <DialogLayout
        open={openSearchLead}
        title="Search Lead"
        onCloseDialog={handleCloseSearchLead}
        maxWIdth="lg"
      >
        <SearchLead
          onSelectLead={(lead) => {
            const selectParamTmp = { ...selectParam };
            selectParamTmp.leadID = lead.ID;
            selectParamTmp.leadName = lead.leadName;
            selectParamTmp.customerID = 0;
            selectParamTmp.customerName = "";
            setSelectParam(selectParamTmp);
            handleCloseSearchLead();
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={handleCloseSearchLead}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchCustomer}
        title="Search Customer"
        onCloseDialog={handleCloseSearchCustomer}
        maxWIdth="lg"
      >
        <SearchCustomer
          onSelectCustomer={(customer) => {
            const selectParamTmp = { ...selectParam };
            selectParamTmp.leadID = 0;
            selectParamTmp.leadName = "";
            selectParamTmp.customerID = customer.ID;
            selectParamTmp.customerName = customer.customerName;
            setSelectParam(selectParamTmp);
            handleCloseSearchCustomer();
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={handleCloseSearchCustomer}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchSales}
        title="Search Sales"
        onCloseDialog={handleCloseSearchSales}
        maxWIdth="lg"
      >
        <SearchUser
          salesUser="true"
          onSelectUser={(user) => {
            const selectParamTmp = { ...selectParam };
            selectParamTmp.assignedUserID = user.ID;
            selectParamTmp.assignedUserName = user.fullName;
            setSelectParam(selectParamTmp);
            handleCloseSearchSales();
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={handleCloseSearchSales}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSalesCardForm}
        title="Sales Card Form"
        maxWIdth="sm"
        onCloseDialog={handleCloseSalesCardForm}
      >
        <SalesCardForm
          salesCard={salesCard}
          onCloseDialog={handleCloseSalesCardForm}
          onConfirmSave={() => {
            getSalesCardsData();
            handleCloseSalesCardForm();
          }}
        />
      </DialogLayout>
      <DialogLayout
        open={openSalesCardDetail}
        title="Sales Card Detail"
        minHeight={true}
        onCloseDialog={handleCloseSalesCardDetail}
      >
        <SalesCardDetail
          salesCardID={salesCardID}
          onCloseDialog={handleCloseSalesCardDetail}
          onReloadSalesCards={() => {
            getSalesCardsData();
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={handleCloseSalesCardDetail}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSalesWonDialog}
        title="Sales Won"
        onCloseDialog={handleCloseSalesWonDialog}
      >
        {salesCard.quotationID > 0 ? (
          <ConvertToSalesOrderWizard
            history={history}
            quotationID={salesCard.quotationID}
            onConfirmSave={() => {
              getSalesCardsData().then((response) => {
                dragCard(cardBoard, 9999);
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Won",
                  text: "Sales Card has been won",
                  icon: "success",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
                handleCloseSalesWonDialog(false);
              });
            }}
            onCloseDialog={() => {
              getSalesCardsData();
              setOpenSalesWonDialog(false);
            }}
          />
        ) : null}
      </DialogLayout>
    </React.Fragment>
  );

  function handleCloseSalesWonDialog() {
    setOpenSalesWonDialog(false);
  }

  async function getSalesCardData(salesCardID) {
    const response = await getSalesCardDetail(salesCardID);
    const { data } = response.data;
    setSalesCard(data.salesCard);
  }

  async function getSalesCardsData() {
    const response = await getBoardSalesCards(
      selectParam.dateFrom,
      selectParam.dateTo,
      selectParam.leadID,
      selectParam.customerID,
      selectParam.assignedUserID
    );
    const { data, auth } = response.data;
    setBoards(data.salesCards);
    setAuth(auth);
  }

  async function dragCard(card, targetLaneId) {
    return updateSalesCardStatus(card, parseInt(targetLaneId));
  }

  function handleCloseSalesCardForm() {
    setOpenSalesCardForm(false);
  }

  function handleCloseSalesCardDetail() {
    setOpenSalesCardDetail(false);
  }

  function handleCloseSearchCustomer() {
    setOpenSearchCustomer(false);
  }

  function handleCloseSearchLead() {
    setOpenSearchLead(false);
  }

  function handleCloseSearchSales() {
    setOpenSearchSales(false);
  }
}

export default Slc;
